import config from 'react-global-configuration';
import { referenceLoadingStart, referenceLoadingDone } from '../../../actions/UI/ReferenceLoading';

var qs = require('qs'); // TODO: Turn these into separate actions?


export var VIEW_ACTION_REPLACE = 'replace';
export var VIEW_ACTION_APPEND = 'append';
export var viewGet = function viewGet(viewId, displayId) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var filters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var action = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : VIEW_ACTION_REPLACE;
  var referenceLoading = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
  return function (dispatch, getState) {
    if (referenceLoading) {
      dispatch(referenceLoadingStart());
    }

    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var url = "".concat(PATH, "/entity/view/").concat(viewId, "/").concat(displayId, "/results?_format=json&page=").concat(page);

    if (Array.isArray(args) && args.length > 0) {
      var encodedArgs = args.map(function (item) {
        return "args[]=".concat(item);
      }).join('&');
      url = "".concat(url, "&").concat(encodedArgs);
    }

    if (Object.keys(filters).length > 0) {
      var _encodedArgs = qs.stringify({
        filters: filters
      });

      url = "".concat(url, "&").concat(_encodedArgs);
    }

    fetch(url, {
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(viewGetLoaded(viewId, displayId, response, action));

      if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }
    }).catch(function () {
      if (referenceLoading) {
        dispatch(referenceLoadingDone());
      }
    });
  };
};
export var VIEW_GET_LOADED = 'VIEW_GET_LOADED';
export function viewGetLoaded(viewId, displayId, data, action) {
  return {
    type: VIEW_GET_LOADED,
    viewId: viewId,
    displayId: displayId,
    data: data,
    action: action
  };
}
export var viewGetInfo = function viewGetInfo(viewId) {
  return function (dispatch, getState) {
    var API_URL = config.get('API_URL');
    var language = getState().getIn(['ui', 'language']);
    var MULTILINGUAL = config.get('MULTILINGUAL', true);
    var PATH = MULTILINGUAL ? "".concat(API_URL, "/").concat(language) : API_URL;
    var url = "".concat(PATH, "/entity/view/").concat(viewId, "/info?_format=json");
    fetch(url, {
      credentials: 'include'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      dispatch(viewGetInfoLoaded(viewId, response));
    }).catch(function () {// Do nothing.
    });
  };
};
export var VIEW_GET_INFO_LOADED = 'VIEW_GET_INFO_LOADED';
export function viewGetInfoLoaded(viewId, viewInfo) {
  return {
    type: VIEW_GET_INFO_LOADED,
    payload: {
      viewId: viewId,
      viewInfo: viewInfo
    }
  };
}